function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import "./ButtonBase.css";
/**
 * BaseButton
 *
 */

function ButtonBase(_ref) {
  var _classNames;

  var allowMultiLine = _ref.allowMultiLine,
      block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      inverse = _ref.inverse,
      label = _ref.label,
      size = _ref.size,
      srOnlyLabel = _ref.srOnlyLabel,
      rest = _objectWithoutProperties(_ref, ["allowMultiLine", "block", "children", "className", "href", "inverse", "label", "size", "srOnlyLabel"]);

  var buttonClasses = classNames('btn', className, (_classNames = {
    'btn-inverse': inverse,
    'btn-block': block
  }, _classNames["btn-" + size] = size, _classNames['btn-wrapped'] = allowMultiLine && block, _classNames));
  var labelClasses = classNames('btn__label', {
    'sr-only': srOnlyLabel,
    'btn__label--truncate': !allowMultiLine && block,
    'btn__label--wrap': allowMultiLine && block
  });

  if (href) {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: buttonClasses,
      href: href
    }, rest), /*#__PURE__*/React.createElement("span", {
      className: labelClasses
    }, label), children);
  }

  return /*#__PURE__*/React.createElement("button", _extends({
    className: buttonClasses
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: labelClasses
  }, label), children);
}

ButtonBase.propTypes = {
  /** Flag for if the button should wrap long labels to the next line. Requires props.block to also be true. Label will truncate and use ellipsis by default. */
  allowMultiLine: PropTypes.bool,

  /** Flag for if the button is .btn-block (span the full width of a parent) */
  block: PropTypes.bool,

  /** Flag for if the button is disabled */
  disabled: PropTypes.bool,

  /** If href is specified, the component outputs an <a> tag,
   * otherwise, it is a button tag. */
  href: PropTypes.string,

  /** Flag for if the button is is inverse-styled and receives className .btn-inverse */
  inverse: PropTypes.bool,

  /** The text or html to display on the button, required. */
  label: PropTypes.node.isRequired,

  /** Size variation from Baseline. (xl variant is only for EG theme) */
  size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),

  /** Flag for applying .sr-only class to the button label for Screen Readers */
  srOnlyLabel: PropTypes.bool,

  /** Specify the type of button. One of: 'button'|'submit'|'reset' */
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};
ButtonBase.defaultProps = {
  allowMultiLine: false,
  type: 'button'
};
export default ButtonBase;
//# sourceMappingURL=ButtonBase.js.map